// src/components/ProductGridWithBanner.jsx
import ProductBlock from "./ProductBlock";
import aurusCategorySplitImg from '../../assets/img/Aurus/items/b1.jpg';
import aurusCategoryVodaImg from '../../assets/img/Aurus/items/b2.jpg';
import aurusCategoryTeploImg from '../../assets/img/Aurus/items/b3.jpg';



// Динамически загружаем изображения из папки
const imageContext = require.context("../../assets/img/Aurus/items", false, /\.(png|jpe?g|svg)$/);

const images = imageContext.keys().reduce((acc, path) => {
  const filename = path.replace("./", ""); // убираем './'
  acc[filename] = imageContext(path);
  return acc;
}, {});

const products = [
  {
    name: "Обогреватель инфракрасный AURUS AIH W 1000",
    link: "#",
    badges: ["Серия P"],
    colors: ["#d4d4d4"],
    images: ["item3.png"],
    characteristic: "Макс. потребляемая мощность: 1"
  },
  {
    name: "Конвектор электрический AURUS ACH-1502 PF",
    link: "#",
    badges: ["Серия P"],
    colors: ["#d4d4d4", "#333333", "#fdffff"],
    images: ["item1_1.png", "item1_2.png", "item1_3.png"],
    characteristic: "Макс. потребляемая мощность: 1,5"
  },
  {
    name: "Сплит-система инверторного типа AURUS D DC ADI-09HN8/BLACK комплект",
    link: "#",
    badges: ["Серия D"],
    colors: ["#000000", "#b9ad5f"],
    images: ["item2_1.png", "item2_2.png"],
    characteristic: "Номинальная производительность охлаждения: 2.7"
  },
  {
    name: "Обогреватель инфракрасный AURUS AIH W 1000",
    link: "#",
    badges: ["Серия P"],
    colors: ["#d4d4d4"],
    images: ["item3.png"],
    characteristic: "Макс. потребляемая мощность: 1"
  }
];

const ProductGridWithBanner = () => {
  return (
    <section className="bp-block bp-block_mt230">
      
      {/* Сплит-системы */}
      <div className="wrapper mb-5 ">
        <div className="bp-block__container">
          <div className="bp-block__item bp-block__item_double">
            <img src={aurusCategorySplitImg} alt="Каталог баннер" />
            <h2 className="bp-header-h2 bp-header-h2_left-line">
              Бытовые <br /> Сплит-Системы
            </h2>
          </div>

          {products.map((product, idx) => (
            <ProductBlock
              key={idx}
              product={{
                ...product,
                images: product.images.map(img => images[img]) // заменяем строки путей на импорты
              }}
            />
          ))}
        </div>
      </div>


      {/* Водонагреватели */}
      <div className="wrapper mb-5 mt-5">
        <div className="bp-block__container">
          <div className="bp-block__item bp-block__item_triple">
            <img src={aurusCategoryVodaImg} alt="Каталог баннер" />
            <h2 className="bp-header-h2 bp-header-h2_left-line">
              Водонагревательная техника
            </h2>
          </div>

          {products.slice(0, 3).map((product, idx) => (
            <ProductBlock
              key={idx}
              product={{
                ...product,
                images: product.images.map(img => images[img]) // заменяем строки путей на импорты
              }}
            />
          ))}
        </div>
      </div>


       {/* Тепловая техника */}
      <div className="wrapper mb-5 mt-5">
        <div className="bp-block__container">
          <div className="bp-block__item bp-block__item_double">
            <img src={aurusCategoryTeploImg} alt="Каталог баннер" />
            <h2 className="bp-header-h2 bp-header-h2_left-line">
              Тепловая <br /> техника
            </h2>
          </div>

          {products.map((product, idx) => (
            <ProductBlock
              key={idx}
              product={{
                ...product,
                images: product.images.map(img => images[img]) // заменяем строки путей на импорты
              }}
            />
          ))}
        </div>
      </div>

    </section>
    
  );
};

export default ProductGridWithBanner;
